const elementsData = (el, parent = {}, childrenId, form) => {
  if (el.children) {
    return {
      ...el,
      children: el.children.map((child) => updateDataElementChildren(child, parent, childrenId, form))
    }
  }
  if (el.elements) {
    return {
      ...el,
      elements: el.elements.map((child) => updateDataElementChildren(child, parent, childrenId, form))
    }
  }
  return el
}

export const updateDataElementChildren = (el, parent = {}, childrenId, form) => {
  if (String(childrenId) === String(el._id)) {
    const formData = {
      name: form.name,
      shortName: form.shortName,
      icon: form.icon,
      mandatory: form.mandatory,
      primaryColor: form.primaryColor || null,
      secondaryColor: form.secondaryColor || null
    }
    if (form.code) {
      formData.code = form.code
    }
    if (form.mandatory) {
      formData.mandatory = form.mandatory
    }
    if (form.elementStructureId) {
      formData.elementStructureId = form.elementStructureId
    }

    return {
      ...el,
      ...formData
    }
  } else if (parent) {
    if (parent.parent) {
      return elementsData(el, parent.parent, childrenId, form)
    } else {
      return elementsData(el, parent, childrenId, form)
    }
  } else {
    return el
  }
}

const addElement = (el, parent = {}, childrenId, form) => {
  if (el.children) {
    return {
      ...el,
      children: el.children.map((child) => addDataElementChildren(child, parent, childrenId, form))
    }
  }
  if (el.elements) {
    return {
      ...el,
      elements: el.elements.map((child) => addDataElementChildren(child, parent, childrenId, form))
    }
  }
  return el
}

export const addDataElementChildren = (el, parent = {}, childrenId, form) => {
  if (String(childrenId) === String(el._id)) {
    const formData = {
      name: form.name,
      shortName: form.shortName,
      icon: form.icon,
      primaryColor: form.primaryColor || null,
      secondaryColor: form.secondaryColor || null
    }
    if (form.code) {
      formData.code = form.code
    }
    if (form.mandatory) {
      formData.mandatory = form.mandatory
    }
    if (form.elementStructureId) {
      formData.elementStructureId = form.elementStructureId
    }

    if (el.children) {
      const children = el.children || []
      children.push(formData)
      return {
        ...el,
        children
      }
    }
    if (el.elements) {
      const elements = el.elements || []
      elements.push(formData)
      return {
        ...el,
        elements
      }
    }
  } else if (parent) {
    if (parent.parent) {
      return addElement(el, parent.parent, childrenId, form)
    } else {
      return addElement(el, parent, childrenId, form)
    }
  } else {
    return el
  }
}

const dataCloneRemoveId = (el) => {
  delete el._id
  if (el.children) {
    return {
      ...el,
      children: el.children.map((child) => dataCloneRemoveId(child))
    }
  }
  if (el.elements) {
    return {
      ...el,
      elements: el.elements.map((child) => dataCloneRemoveId(child))
    }
  }
  return el
}

export const cloneDataElementChildren = (el, parent = {}, childrenId, form) => {
  if (String(childrenId) === String(el._id)) {
    const formData = form

    if (el.children) {
      const children = el.children || []
      delete formData._id
      children.push(dataCloneRemoveId(formData))
      return {
        ...el,
        children
      }
    }
    if (el.elements) {
      const elements = el.elements || []
      delete formData._id
      elements.push(dataCloneRemoveId(formData))
      return {
        ...el,
        elements
      }
    }
  } else if (parent) {
    if (parent.parent) {
      return addElement(el, parent.parent, childrenId, form)
    } else {
      return addElement(el, parent, childrenId, form)
    }
  } else {
    return el
  }
}

const mapElementData = (el, parent = {}, childrenId) => {
  if (el.children) {
    return {
      ...el,
      children: el.children.map((child) => deleteDataElementChildren(child, parent, childrenId))
    }
  }
  if (el.elements) {
    return {
      ...el,
      elements: el.elements.map((child) => deleteDataElementChildren(child, parent, childrenId))
    }
  }
  return el
}
export const deleteDataElementChildren = (el, parent = {}, childrenId) => {
  if (String(childrenId) === String(el._id)) {
    return null
  } else if (parent) {
    if (parent.parent) {
      return filterNull(mapElementData(el, parent.parent, childrenId))
    } else {
      return filterNull(mapElementData(el, parent, childrenId))
    }
  } else {
    return filterNull(el)
  }
}

export const filterNull = (el) => {
  if (el.children) {
    return {
      ...el,
      children: el.children.filter((child) => child)
    }
  }
  if (el.elements) {
    return {
      ...el,
      elements: el.elements.filter((child) => child)
    }
  }
  return el
}

export const setParentData = (data, parent) => {
  if (parent) {
    if (parent.parent) {
      return {
        ...parent,
        parent: setParentData(data, parent.parent)
      }
    } else {
      return {
        ...parent,
        parent: data
      }
    }
  } else {
    return data
  }
}
